import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { listActiveMeridioPlanEnrollments } from "../../services/api/benefits/meridioPlanEnrollment/listActiveMeridioPlanEnrollments";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const QUERY_ACTIVE_MERIDIO_PLAN_ENROLLMENTS =
  "QUERY_ACTIVE_MERIDIO_PLAN_ENROLLMENTS";

export const useQueryActiveMeridioPlanEnrollments = (
  config?: WSQueryConfig<IPlanEnrollment[], WSServiceError>
) =>
  useWSQuery<IPlanEnrollment[], WSServiceError>(
    QUERY_ACTIVE_MERIDIO_PLAN_ENROLLMENTS,
    listActiveMeridioPlanEnrollments,
    config
  );
